import React from "react";

export default function ErrorPage() {
  return (
    <div className="error-page-container">
      <iframe
        title="error-page"
        src="https://lottie.host/embed/28dd2011-31ae-4bd4-925b-eea12889c22d/bPWVojiDCl.json"
      ></iframe>
      <p>404</p>
    </div>
  );
}
